<header class="static-header">
  <div class="header-container">
    <!-- Logo on the left -->
    <div class="logo">
      <a href="https://gs1pt.org/"> <img src="assets/logo.svg" alt="GS1 Portugal Logo" /></a>
    </div>
    <!-- Action buttons with nav-menu -->
    <div class="header-actions">
      <!-- Navigation menu -->
      <nav class="nav-menu">
          <!-- <a aria-label="Home" [routerLink]="['/home']" *ngIf="!(isHomePage$ | async)">
            <i class="bi bi-house"></i>
          </a> -->
      </nav>
      <button  class="btn btn-primary btn-home-search" (click)="navigateToAdesao()">Adesão</button>
      <button  class="btn btn-icon" (click)="navigateToAreaDoAssociado()">
        <img src="assets/icon-menu.svg" alt="Área do Associado" />
      </button>
    </div>
  </div>
</header>